import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPlayerPrefetchResult } from '../lib/playerPrefetch';
import { useInitialParamsSnapshot } from './useInitialParams';

const DEFAULT_REGION = 'US';

export const usePlayerBootstrap = (): void => {
  const navigate = useNavigate();
  const { player, rawRegion, setRegion } = useInitialParamsSnapshot();

  useEffect(() => {
    if (!player) return;
    if (!getPlayerPrefetchResult().hasCredentials) return;
    if (!rawRegion) setRegion(DEFAULT_REGION);
    navigate('/connect/signin', { replace: true });
  }, [navigate, player, rawRegion, setRegion]);
};
